package com.hyperether.planner.util

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.unit.Density
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.sp


fun dpToSizeInPx(maxWidth: Dp, maxHeight: Dp, density: Density): Size {
    val widthPx = with(density) { maxWidth.toPx() }
    val heightPx = with(density) { maxHeight.toPx() }
    return Size(widthPx, heightPx)
}

val containerSize: MutableState<Size> = mutableStateOf(Size.Zero)
val containerSizeDp: MutableState<Dp> = mutableStateOf(Dp(0f))
fun Sp(size: Float): TextUnit = when {
//    isWebMobileView() -> (size * 3).sp // TODO: check how it looks on Android device Web
    is4K() -> (size * 2).sp
    else -> size.sp
}

fun Dp(size: Float): Dp = when {
//    isWebMobileView() -> Dp(size * 3) // TODO: check how it looks on Android device Web
    is4K() -> Dp(size * 2)
    else -> Dp(size)
}

fun is4K(): Boolean {
//    log.d("SIZE RESOLUTION: ") { "IS 4K:  width=${containerSize.value.width}, height=${containerSize.value.height}" }
    return containerSize.value.width >= 3700f && containerSize.value.height >= 2090f
}
